import { auditReportsExecuteBcrMatchesReport } from '@mi-front/api-v2';
import { DateStr, today } from '@mi-front/core';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { BcrMatchesReportEmptyState } from './BcrMatchesReportEmptyState';
import { BcrMatchesReportForm } from './BcrMatchesReportForm';
import { BcrMatchesReportResult } from './BcrMatchesReportResult';
import { BcrMatchesReport } from './types';
import { Station } from '@app/core/types/stations';

export function BcrMatchesReportView(p: { station: Station }) {
  const tz = useTimezone();

  const resetValues = {
    date: today() as DateStr,
  };

  return (
    <ReportView<BcrMatchesReport>
      defaultValues={resetValues}
      reportFn={(values) => {
        return auditReportsExecuteBcrMatchesReport({
          stationId: p.station.slug,
          date: values.date,
          customId: values.customId || undefined,
        });
      }}
      Form={BcrMatchesReportForm}
      Result={BcrMatchesReportResult}
      emptyResult={<BcrMatchesReportEmptyState />}
    />
  );
}
